import { useFormik } from "formik";
import TextInput from "../../../../components/inputs/textInput";
import { useTranslation } from "react-i18next";
import DeliveryTruckICon from "../../../../icons/deliveryTruckIcon";
import AirPlaneIcon from "../../../../icons/airPlaneIcon";
import Button from "../../../../components/buttons/button";
import UserIcon from "../../../../icons/userIcon";
import BoxIcon from "../../../../icons/boxIcon";
import PhoneIcon from "../../../../icons/phoneIcon";
import ShoppingBasketIcon from "../../../../icons/shoppingBasketIcon";
import PackageIcon from "../../../../icons/packageIcon";
import LocationIcon from "../../../../icons/locationIcon";
import ShipmentDeliveredIcon from "../../../../icons/shipmentDeliveredIcon";
import { useState } from "react";
import MessagePopup from "../../../../components/popups/messagePopup";

const RequestOfferPrice = () => {
  const [requestSent, setRequestSent] = useState(false);
  const formik = useFormik({
    initialValues: {
      shipmentType: "fast",
      shipmentType2: "land",
    },
    onSubmit: (values) => {
      setRequestSent(true);
    },
  });

  const { t } = useTranslation();
  return (
    <main className="relative">
      <h2 className="my-4 text-xl capitalize">{t("customerDetails")}</h2>
      <form onSubmit={formik.handleSubmit}>
        <section className="inputs">
          <TextInput
            icon={<UserIcon />}
            formik={formik}
            label={t("name")}
            name={"name"}
            placeholder={t("enterCustomerName")}
          />
          <TextInput
            icon={<PhoneIcon fill={"#888888"} className="size-6" />}
            formik={formik}
            label={t("phone")}
            name={"phone"}
            placeholder={t("enterPhoneNumber")}
          />
        </section>
        <h2 className="my-4 text-xl capitalize">{t("goodsDetails")}</h2>
        <section className="inputs">
          <TextInput
            icon={<BoxIcon fill={"#888888"} className="size-6" />}
            formik={formik}
            label={t("type")}
            name={"type"}
            placeholder={t("type")}
          />
          <TextInput
            icon={<ShoppingBasketIcon />}
            formik={formik}
            label={t("weight")}
            name={"weight"}
            placeholder={t("weight")}
          />
          <TextInput
            icon={<PackageIcon />}
            formik={formik}
            label={t("quantity")}
            name={"quantity"}
            placeholder={t("quantity")}
          />
        </section>
        <h2 className="my-4 text-xl capitalize">{t("addresses")}</h2>
        <section className="inputs">
          <TextInput
            icon={<LocationIcon className="size-6" fill={"#888888"} />}
            formik={formik}
            label={t("deliveryAddress")}
            name={"deliveryAddress"}
            placeholder={t("deliveryAddress")}
          />
          <TextInput
            icon={<LocationIcon className="size-6" fill={"#888888"} />}
            formik={formik}
            label={t("receiptAddress")}
            name={"receiptAddress"}
            placeholder={t("receiptAddress")}
          />
        </section>
        <h2 className="my-4 text-xl capitalize">{t("shipmentType")}</h2>
        <section className="inputs">
          <label
            htmlFor="shipment-type-normal"
            className={`w-full p-4 font-bold text-center capitalize transition-all  rounded-lg cursor-pointer ${
              formik.values.shipmentType === "normal"
                ? "text-white bg-mainBlue"
                : "bg-white text-mainGray"
            }`}
          >
            <input
              type="radio"
              name="shipmentType"
              className="absolute top-0 left-0 hidden"
              id="shipment-type-normal"
              onChange={formik.handleChange}
              value={"normal"}
            />
            {t("normal")}
          </label>
          <label
            htmlFor="shipment-type-fast"
            className={`w-full p-4 font-bold text-center capitalize transition-all  rounded-lg cursor-pointer ${
              formik.values.shipmentType === "fast"
                ? "text-white bg-mainBlue"
                : "bg-white text-mainGray"
            }`}
          >
            <input
              type="radio"
              name="shipmentType"
              className="absolute top-0 left-0 hidden"
              id="shipment-type-fast"
              onChange={formik.handleChange}
              value={"fast"}
            />
            {t("fast")}
          </label>
        </section>
        <h2 className="my-4 text-xl capitalize">{t("shipmentType")}</h2>
        <section className="inputs">
          <label
            htmlFor="shipment-type-land"
            className={`flex items-center justify-center w-full gap-2 p-4 font-bold text-center capitalize transition-all  rounded-lg cursor-pointer ${
              formik.values.shipmentType2 === "land"
                ? "text-white bg-mainBlue"
                : "bg-white text-mainGray"
            }`}
          >
            <input
              type="radio"
              name="shipmentType2"
              className="absolute top-0 left-0 hidden"
              id="shipment-type-land"
              onChange={formik.handleChange}
              value={"land"}
            />
            <DeliveryTruckICon
              fill={formik.values.shipmentType2 === "land" ? "white" : ""}
            />
            {t("land")}
          </label>
          <label
            htmlFor="shipment-type-air"
            className={`flex items-center justify-center w-full gap-2 p-4 font-bold text-center capitalize transition-all rounded-lg cursor-pointer ${
              formik.values.shipmentType2 === "air"
                ? "text-white bg-mainBlue"
                : "bg-white text-mainGray"
            }`}
          >
            <input
              type="radio"
              name="shipmentType2"
              className="absolute top-0 left-0 hidden"
              id="shipment-type-air"
              onChange={formik.handleChange}
              value={"air"}
            />
            <AirPlaneIcon fill={formik.values.shipmentType2 === "air" ? "white" : ""} />
            {t("fast")}
          </label>
        </section>
        <Button text={t("sendRequest")} className={"bg-mainRed py-2 my-4"} />
      </form>
      <MessagePopup
        text={t("requestSentSuccess")}
        icon={<ShipmentDeliveredIcon className="size-20" />}
        state={requestSent}
        setState={setRequestSent}
      />
    </main>
  );
};

export default RequestOfferPrice;
